import gql from 'graphql-tag'

// some fields omitted here as an extra precaution for anonymity

export default gql`
query listUsers {
    listUsers {
            items {
                    id
                    goals
                    voicePursuit
                    gender
                    Age
                    voiceType
                    voiceDescriptives
            }
    }
}`



// WEBPACK FOOTER //
// ./src/components/queries/ListUsersQuery.js